import { useEffect, useState } from "react"
import MajorMedDepartment from "./MajorMedDepartment"
import { departmentsOptions } from "../../../../lib/systemData"

import classes from './MajorMedDepartment.module.css'

export default function MajorMedDepartments({data}) {
    const [departments, setDepartments] = useState(null)

    useEffect(() => {
        let d = departmentsOptions()
        if (d) {
            setDepartments(d)
        } else {
            setDepartments(null)
        }
    }, [])

    return <div>
        {departments && <table>
            <thead>
                <tr>
                    <th className={classes.cell_1}>Departments</th>
                    <th className={classes.cell_1}># of Visits</th>
                    <th className={classes.cell_1}>Limits</th>
                    <th>PreAuth Needed</th>
                    <th className={'table-cell-fit'}>Show active only</th>
                </tr>
            </thead>
            <tbody>
                {departments && departments.map(department => (
                    <MajorMedDepartment key={department.id} itemData={department} majorMedData={data}/>
                ))}
            </tbody>
        </table>}
    </div>
}